const setBaseURL = () => {
  let temp = window.location.href.split("/");
  let url = temp[2];
  if (
    url === "shelldashboard.oscar.pk" ||
    url === "shellcentral.oscar.pk" ||
    url === "dashstage.oscar.pk" ||
    url === "dashboard.oscarhub.org" ||
    url === "dashboard.oscar.pk" ||
    url === "total-dashboard.oscar.pk" ||
    url === "analyticshub.oscar.pk"
  ) {
    return `https://${url}/`;
  } else {
    return 'https://dashboard.oscar.pk/';
    // return 'http://127.0.0.1:8000/';
    // return 'https://analytics.oscarhub.org/';
    // return 'http://192.168.10.14:8000/'
  }
};

// export const RECAPTCHA_SITE_KEY = '6Ld4L7UcAAAAAFtW4FDvJyitg3tGzFJX2Gro4iOA';
export const RECAPTCHA_SITE_KEY = '6Le_BlkcAAAAAHbikcxYqjooYvfsiD5PZ22O6FZq';
export const BASE_URL = setBaseURL();
// export const BASE_URL = 'https://total-dashboard.oscar.pk/'; // In Dev, use this as BaseURL
// export const BASE_URL = 'http://192.168.50.20:8000/'; // In Dev, use this as BaseURL

export const getUrl = (type, user_type) => {
  console.log(type, "type");
  console.log(user_type, "user_type");
  switch (type) {
    case "retail":
      var subUrl = () => {
        switch (user_type) {
          case "head_office":
            return "/dashboard";
          case "shell_head_office":
            return "/dashboard";
          case "helix_head_office":
            return "/dashboard/helix";
          case "total_head_office":
            return "/dashboard";
          case "operator":
            return "/dashboard/sales";
          case "artisan_head_office":
            return "/dashboard/sales";
          case "ke_account":
            return "/dashboard/ke";
          default:
            return "/dashboard/sales";
        }
      };
      return subUrl();
    case "operator":
      return "/dashboard/sales";
    case "helix":
      return "/dashboard/helix";
    case "restaurant":
      return "/dashboard/restaurant";
    default:
      return "/dashboard/sales";
    // default:                 # MODIFY FOR REPORTING #
    //   return "/dashboard";
  }
};



// WEBPACK FOOTER //
// ./src/constants/constants.js